var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsersLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M33 15.5C33 17.8561 31.9136 19.9584 30.2144 21.3333C28.9263 22.3757 27.2861 23 25.5 23C23.7139 23 22.0737 22.3757 20.7856 21.3333C19.0864 19.9584 18 17.8561 18 15.5C18 11.3579 21.3579 8 25.5 8C29.6421 8 33 11.3579 33 15.5Z",
    fill: "#F93749"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M48 22C48 23.8848 47.1309 25.5667 45.7716 26.6667C44.7411 27.5005 43.4289 28 42 28C40.5711 28 39.2589 27.5005 38.2284 26.6667C36.8691 25.5667 36 23.8848 36 22C36 18.6863 38.6863 16 42 16C45.3137 16 48 18.6863 48 22Z",
    fill: "#F93749"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M26 31C18.8203 31 13 37.7157 13 46H39C39 37.7157 33.1797 31 26 31Z",
    fill: "#F93749"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M42.0001 34C36.4772 34 38.5001 39.3726 38.5001 46H52.0001C52.0001 39.3726 47.5229 34 42.0001 34Z",
    fill: "#F93749"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 16.5C16.5 12.0817 20.0817 8.5 24.5 8.5C28.9183 8.5 32.5 12.0817 32.5 16.5C32.5 19.0125 31.3435 21.2538 29.5281 22.7228C28.1537 23.8349 26.4066 24.5 24.5 24.5C22.5934 24.5 20.8463 23.8349 19.4719 22.7228C17.6565 21.2538 16.5 19.0125 16.5 16.5ZM34 16.5C34 19.4843 32.6239 22.1473 30.4716 23.8889C28.84 25.2092 26.7624 26 24.5 26C22.2376 26 20.16 25.2092 18.5284 23.8889C16.3761 22.1473 15 19.4843 15 16.5C15 11.2533 19.2533 7 24.5 7C29.7467 7 34 11.2533 34 16.5ZM10.75 46C10.75 37.5065 16.9738 30.75 24.5 30.75C32.0262 30.75 38.25 37.5065 38.25 46C38.25 46.4142 38.5858 46.75 39 46.75C39.4142 46.75 39.75 46.4142 39.75 46C39.75 36.8204 32.9901 29.25 24.5 29.25C16.0099 29.25 9.25 36.8204 9.25 46C9.25 46.4142 9.58579 46.75 10 46.75C10.4142 46.75 10.75 46.4142 10.75 46Z",
    fill: "#F93749"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.6662 14.416C40.252 14.416 39.9162 14.7518 39.9162 15.166C39.9162 15.5802 40.252 15.916 40.6662 15.916C43.8418 15.916 46.4162 18.4904 46.4162 21.666C46.4162 23.472 45.5845 25.0832 44.2803 26.1385C43.2925 26.9378 42.0362 27.416 40.6662 27.416C39.2962 27.416 38.0399 26.9378 37.0521 26.1385C36.7301 25.878 36.2579 25.9278 35.9973 26.2498C35.7368 26.5718 35.7866 27.044 36.1086 27.3046C37.3536 28.312 38.9404 28.916 40.6662 28.916C42.392 28.916 43.9788 28.312 45.2238 27.3046C46.8649 25.9767 47.9162 23.9439 47.9162 21.666C47.9162 17.662 44.6703 14.416 40.6662 14.416ZM40.4678 33.0601C40.0536 33.0601 39.7178 33.3958 39.7178 33.8101C39.7178 34.2243 40.0536 34.5601 40.4678 34.5601C46.1679 34.5601 50.8818 39.5537 50.8818 45.8328C50.8818 46.247 51.2176 46.5828 51.6318 46.5828C52.046 46.5828 52.3818 46.247 52.3818 45.8328C52.3818 38.8319 47.0991 33.0601 40.4678 33.0601Z",
    fill: "#F93749"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12 26.3642L1.00005 26.3642",
    stroke: "#F93749",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersLeft);
export default __webpack_public_path__ + "static/media/users-left.d7e2b9ea9c0c5c36e27666f2091629e5.svg";
export { ForwardRef as ReactComponent };